const GITHUB_ROOT = 'github'

export const githubRoutes = {
  link: () => `${GITHUB_ROOT}/link`,
  token: () => `token`,
  check: () => `${GITHUB_ROOT}`
}
